module.exports = __webpack_public_path__ + "img/tijiao.af5aa720.png";